import GroupAccess from './GroupAccess.component';

export default GroupAccess;
